import { render, staticRenderFns } from "./LeaderboardPlayer.vue?vue&type=template&id=c99aaaa6&scoped=true&"
import script from "./LeaderboardPlayer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardPlayer.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardPlayer.vue?vue&type=style&index=0&id=c99aaaa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99aaaa6",
  null
  
)

export default component.exports